$(document).ready(function () {
    if (window.innerWidth > 1024) {
        var intervalSlideAndHideText;

        function startAutoPlaySlideAndHideText() {
            clearInterval(intervalSlideAndHideText);
            intervalSlideAndHideText = setInterval(function () {
                var activeLink = $('.slideAndHideText-linkAndHideTextDiv.active');
                var nextLink = activeLink.next('.slideAndHideText-linkAndHideTextDiv');

                if (nextLink.length === 0) {
                    nextLink = $('.slideAndHideText-linkAndHideTextDiv:first-child');
                }

                nextLink.trigger('click');
            }, 5000);
        }

        function stopAutoPlaySlideAndHideText() {
            clearInterval(intervalSlideAndHideText);
        }

        var defaultLink = $('.slideAndHideText-linkAndHideTextDiv:first-child');
        var underline = $('.underline');

        let underlineHeight = $("#slideAndHideText-link-1").height() + $("#hideText-1").outerHeight();
        underline.css('height', underlineHeight);
        underline.css('top', 'calc(' + defaultLink.position().top + 'px + 0.7vw )');

        $('.slideAndHideText-link').removeClass('active');
        defaultLink.addClass('active');

        $('.slideImage:not("#slideAndHideText-image1")').hide();
        $("#hideText-1").css('display', 'block');

        $('.slideAndHideText-linkAndHideTextDiv').click(function (e) {
            e.preventDefault();

            stopAutoPlaySlideAndHideText();

            var newImage = $(this).data('image');

            $('.slideAndHideText-linkAndHideTextDiv').removeClass('active');
            $(this).addClass('active');

            $('.slideImage').hide();
            $('#' + newImage).css('display', 'flex');

            $(".hideText").stop().slideUp(500);
            $("#hideText-" + $(this).data("index")).stop().slideDown(500);

            let underlineHeight = $("#slideAndHideText-link-" + $(this).data("index")).height() +
                $("#hideText-" + $(this).data("index")).outerHeight();

            underline.css('height', underlineHeight);

            sleep(450).then(() => {
                underline.css('top', 'calc(' + $(this).position().top + 'px + 0.7vw )');
                stopAutoPlaySlideAndHideText();
            });
        });

        function sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        }

        $(".slideImage").hover(
            function () {
                stopAutoPlaySlideAndHideText();
            },
            function () { }
        );

        // ==============================
        // ✅ 滚动优化核心（只优化这里）
        // ==============================

        const container = document.getElementById('power_and_charging');
        let ticking = false;
        let lastSwitchIndex = 1;
        let lastTriggerTime = 0;

        const items = $('.slideAndHideText-linkAndHideTextDiv');

        // ⭐ 参数（可以微调）
        const SWITCH_THRESHOLD = 0.3;   // 越大越不敏感
        const SWITCH_COOLDOWN = 500;     // 最小切换间隔(ms)

        function getActiveIndexByScroll() {
            const rect = container.getBoundingClientRect();
            const windowH = window.innerHeight;

            const progress = Math.min(
                1,
                Math.max(0, (windowH - rect.top) / (windowH + rect.height))
            );

            // ⭐ 加缓冲区（核心）
            const adjusted = Math.max(0, progress - SWITCH_THRESHOLD) / (1 - SWITCH_THRESHOLD);

            const index = Math.ceil(adjusted * items.length);

            return Math.min(items.length, Math.max(1, index));
        }

        function update() {
            const now = Date.now();

            // ⭐ 节流
            if (now - lastTriggerTime < SWITCH_COOLDOWN) {
                ticking = false;
                return;
            }

            const index = getActiveIndexByScroll();

            if (index !== lastSwitchIndex) {
                lastSwitchIndex = index;
                lastTriggerTime = now;

                const target = items.eq(index - 1);
                if (target.length) {
                    target.trigger('click');
                }
            }

            ticking = false;
        }

        window.addEventListener('scroll', function () {
            if (!ticking) {
                requestAnimationFrame(update);
                ticking = true;
            }
        });
    }

    // ==============================
    // ✅ 移动端轮播
    // ==============================
    if (window.innerWidth <= 1024) {
        const container = $('#power_and_charging-mobile');
        const items = container.find('.slideItem');
        const counter = container.find('.slideCounter');
        const navRight = container.find('.navRight');
        const prevBtn = navRight.find('.prevArrow');
        const nextBtn = navRight.find('.nextArrow');
        const prevRing = prevBtn.find('.progressRingFill');
        const nextRing = nextBtn.find('.progressRingFill');
        let currentIndex = 1;
        const total = items.length;
        let autoPlayTimer;
        let direction = 1;
        let slideInterval = parseInt(container.data('slide-time')) || 5000;
        const circumference = 119.38;

        function resetRing() {
            prevRing.css('transition', 'none').removeClass('animating').css('stroke-dashoffset', circumference);
            nextRing.css('transition', 'none').removeClass('animating').css('stroke-dashoffset', circumference);

            const target = direction === 1 ? nextRing : prevRing;
            void target[0].offsetWidth;
            target.addClass('animating');
            target.css('transition', 'stroke-dashoffset ' + (slideInterval / 1000) + 's linear');
            target.css('stroke-dashoffset', 0);
        }

        function goToSlide(index) {
            if (index < 1) index = total;
            if (index > total) index = 1;
            currentIndex = index;

            items.removeClass('active');
            container.find('.slideItem[data-index="' + index + '"]').addClass('active');

            counter.text(index + '/' + total);
        }

        function goToNextSlide() {
            goToSlide(currentIndex + direction);
            direction = -direction;
            resetRing();
        }

        function startAutoPlay() {
            stopAutoPlay();
            resetRing();
            autoPlayTimer = setInterval(function () {
                goToNextSlide();
            }, slideInterval);
        }

        function stopAutoPlay() {
            clearInterval(autoPlayTimer);
            prevRing.css('transition', 'none').removeClass('animating').css('stroke-dashoffset', circumference);
            nextRing.css('transition', 'none').removeClass('animating').css('stroke-dashoffset', circumference);
        }

        prevBtn.on('click', function (e) {
            e.preventDefault();
            stopAutoPlay();
            goToSlide(currentIndex - 1);
            direction = 1;
            startAutoPlay();
        });

        nextBtn.on('click', function (e) {
            e.preventDefault();
            stopAutoPlay();
            goToSlide(currentIndex + 1);
            direction = -1;
            startAutoPlay();
        });

        resetRing();
        goToSlide(1);
        startAutoPlay();
    }
});

// ==============================
// ✅ 移动端展开收起（保持不变）
// ==============================
function showAndHideMobile(e, id) {
    e.preventDefault();
    showAndHideMobileById(id);
}

function showAndHideMobileById(id) {
    $(".hideTextContentDiv_mobile").removeClass('activeHideTextContentDiv_mobile');
    $("#hideTextContentDiv_mobile-" + id).addClass('activeHideTextContentDiv_mobile');

    $(".headingContent-arrow_mobile").css(
        "background-image",
        "url('{{'ChevronDownMinor.svg' | asset_url}}')"
    );

    if ($("#hideTextContent_mobile" + id).css("display") === "none") {
        $("#hideTextArrow_mobile" + id).css(
            "background-image",
            "url('{{'ChevronUpMinor.svg' | asset_url}}')"
        );
    } else {
        $("#hideTextArrow_mobile" + id).css(
            "background-image",
            "url('{{'ChevronDownMinor.svg' | asset_url}}')"
        );
    }

    $(".hideTextContent_mobile").each(function () {
        if ($(this).attr("id") != "hideTextContent_mobile" + id) {
            $(this).slideUp();
        }
    });

    $("#hideTextContent_mobile" + id).slideToggle();
}